import React, { useEffect, useMemo } from "react";
import { usePocket } from "@/contexts/PocketContext";
import { useAuth } from "@/contexts/AuthContext";
import { navigate } from "vike/client/router";
import { useAgents } from "@/hooks/use-agents";
import { useSales } from "@/hooks/use-sales";
import DashboardContent from "./DashboardContent";

export default function DashboardPage() {
  const { user } = usePocket();
  const { isLoading } = useAuth();
  const { agents, isLoading: agentsLoading } = useAgents();
  const { sales, isLoading: salesLoading } = useSales({
    status: "unpaid",
  });
  const totalToPay = useMemo(() => sales.reduce((sum, s) => sum + s.commission, 0), [sales]);

  const topAgents = useMemo(() => {
    const weekAgo = new Date();
    weekAgo.setDate(weekAgo.getDate() - 7);
    const weekSales = sales.filter((s) => new Date(s.saleDate) >= weekAgo);

    const agentStats = agents.map((agent) => {
      const agentSales = weekSales.filter((s) => s.agent === agent.id);
      const totalCommission = agentSales.reduce((sum, s) => sum + s.commission, 0);
      return {
        ...agent,
        salesCount: agentSales.length,
        totalCommission,
      };
    });

    return agentStats.sort((a, b) => b.totalCommission - a.totalCommission).slice(0, 3);
  }, [agents, sales]);

  const agentsWithStats = useMemo(() => {
    return agents.map((agent) => {
      const agentSales = sales.filter((s) => s.agent === agent.id);
      const unpaidTotal = agentSales.reduce((sum, s) => sum + s.commission, 0);
      return {
        ...agent,
        unpaidCount: agentSales.length,
        unpaidTotal,
      };
    });
  }, [agents, sales]);

  useEffect(() => {
    if (!isLoading && !user) {
      navigate("/auth");
    }
  }, [user, isLoading]);

  if (isLoading || agentsLoading || salesLoading) {
    return <div className="flex items-center justify-center min-h-screen">Загрузка...</div>;
  }

  if (!user) {
    return null;
  }

  return (
    <DashboardContent
      agents={agents}
      sales={sales}
      unpaidSales={sales}
      totalToPay={totalToPay}
      topAgents={topAgents}
      agentsWithStats={agentsWithStats}
    />
  );
}
